<template>
  <v-btn :block="$vuetify.breakpoint.smAndDown" :disabled="loading" :loading="loading" @click="downloadCertificate" large text color="blue">
    <v-icon small left>mdi-download</v-icon>
    {{ __('Download Certificate') }}
    <template v-slot:loader>
      <span class="muted--text">{{ $t('Downloading Certificate...') }}</span>
    </template>
  </v-btn>
</template>

<script>
import $auth from '@/core/Auth/auth'

export default {
  data () {
    return {
      loading: false,
    }
  },

  methods: {
    load (val = true) {
      this.loading = val
    },

    downloadCertificate () {
      this.load()

      let userId = $auth.getId()
      axios.get(
        `/misc/assessments/certificates/download?user_id=${userId}`, {responseType: 'arraybuffer'}
      ).then(response => {
        var file = new Blob([response.data], {type: 'application/pdf'});
        var fileURL = URL.createObjectURL(file);

        let a = document.createElement("a")
        let userDisplayname = $auth.getUser().displayname
        a.href = fileURL;
        a.download = `${userDisplayname}.pdf`;
        document.body.appendChild(a)
        a.click();
        // window.open(fileURL);
        // a.remove();
      }).finally(() => {
          this.load(false)
        })
      // window.open(`/misc/assessments/certificates/download?user_id=${userId}`, '_blank')
    },
  },
}
</script>
